import React from 'react';
import { useSub } from './hooks.js';
import { submitDecisions } from './graphql.js';
import { SAT_FORM, SSS_FORM_OPT_IN, SSS_FORM_AFTER_OPT_IN, NRP_FORM, PSS_FORM, AM_FORM, FA_IDOC_FORM, FA_CSS_FORM, CLEP_FORM, AP_FORM, } from './collectionForms.js';
const FORM_MAP = {
    SAT: SAT_FORM,
    FA_CSS: FA_CSS_FORM,
    FA_IDOC: FA_IDOC_FORM,
    CLEP: CLEP_FORM,
    AM: AM_FORM,
    SSS_OPT_IN: SSS_FORM_OPT_IN,
    SSS_AFTER_OPT_IN: SSS_FORM_AFTER_OPT_IN,
    NRP: NRP_FORM,
    PSS: PSS_FORM,
    AP: AP_FORM,
};
const collectionPointNamesMap = {
    SAT: ['Race/Ethnicity'],
    CLEP: ['Race/Ethnicity'],
    FA_CSS: ['Citizenship'],
    FA_IDOC: ['Sensitive_Information'],
    AM: ['Mental/Physical_Health'],
    SSS: ['Race/Ethnicity'],
    PSS: ['Race/Ethnicity'],
    NRP: ['Race/Ethnicity'],
    AP: ['Race/Ethnicity'],
};
const CONSENT_ENABLED_STATE_CDS = ['CO', 'NJ', 'DE', 'OR', 'MN', 'MD'];
export function getConsentNamesForCollectionPoint(collectionPoint) {
    return collectionPointNamesMap?.[collectionPoint];
}
// function createConsentNameImpactStatementMap(collectionPoint: string) {
//     const consentNames = getConsentNamesForCollectionPoint(collectionPoint);
//     const consentNamesWithImpact = consentNames.map((consentName: string) => {
//         return [consentName, consentReason(consentName)];
//     });
//     return new Map<ConsentId, ConsentReason>(consentNamesWithImpact);
// };
export function defaultConsentStatus(collectionPoint, stateCd) {
    const consentNames = getConsentNamesForCollectionPoint(collectionPoint);
    const consentNamesWithDefaultStatus = consentNames.map((consentName) => {
        return [consentName.toLowerCase(), CONSENT_ENABLED_STATE_CDS.includes(stateCd) ? 'opt-out' : 'opt-in'];
    });
    return new Map(consentNamesWithDefaultStatus);
}
export const ConsentRequester = ({ env, personId, collectionPoint, SSSForm, className, stateCd, suppressForm, }) => {
    // const [consentsRequested, setConsentsRequested] = useState(new Map<ConsentId, ConsentReason>(createConsentNameImpactStatementMap(collectionPoint)));
    useSub('consent-management-submit-decisions', async (event) => {
        const { collectionPoint: payloadCollectionPoint, consents, callback } = event.payload;
        if (payloadCollectionPoint !== collectionPoint) {
            console.log(`${collectionPoint} ConsentRequester is ignoring this event, as it is for ${payloadCollectionPoint}`);
            return;
        }
        //  If not in a consent enabled stateCd, don't submit anything
        if (!CONSENT_ENABLED_STATE_CDS.includes(stateCd)) {
            callback({
                success: `User is not in ${CONSENT_ENABLED_STATE_CDS.join(', ')}, nothing to submit.`,
            });
            return;
        }
        //  If the user did not opt-in to anything, no reason to submit to onetrust
        const noOptIns = Object.values(Object.fromEntries(consents)).every((value) => value === 'opt-out');
        if (noOptIns) {
            callback({
                success: 'User did not opt-in to anything, nothing to submit.',
            });
            return;
        }
        //  Otherwise map purposes for graphql request
        const purposes = {};
        for (let [key, value] of consents) {
            purposes[key.replace('/', '_')] = value;
        }
        if (collectionPoint === 'SSS' && SSSForm === 'AFTER_OPT_IN') {
            callback({ success: 'AFTER_OPT_IN does not submit to onetrust, done.' });
        }
        else {
            const submitted = await submitDecisions(env, personId, stateCd, collectionPoint, purposes);
            callback(submitted ? { success: 'done' } : { error: 'Unable to submit consent decisions' });
        }
    });
    if (!CONSENT_ENABLED_STATE_CDS.includes(stateCd) || suppressForm) {
        return React.createElement(React.Fragment, null);
    }
    const formName = collectionPoint === 'SSS' ? `SSS_${SSSForm}` : collectionPoint;
    const FormToRender = FORM_MAP[formName];
    return (React.createElement("div", { className: className },
        React.createElement(FormToRender, null)));
};
